import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import CafeDiscountsList from './List/index';
import ShowForPermission from '../../components/ShowForPermission';
import CafeDiscountFilter from './cafeDiscountFilter';
import ENUMS from '../../enums';
import Spin from '../../components/loading';
import * as cafeDiscountsActions from '../../redux/cafeDiscounts/actions';
import submitForm from '../../utils/submitForm';

const CafeDiscounts = props => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortType, setSortType] = useState('desc');
  const [sort, setSort] = useState('');
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState('');

  useEffect(() => {
    const query = buildSearchQuery(currentPage, pageSize);
    props.getMyCafeDiscountsList(query);
  }, []);

  useEffect(() => {
    filterAndSort();
  }, [filter]);

  useEffect(() => {
    let searchQuery = buildSearchQuery(currentPage, pageSize);
    props.getMyCafeDiscountsList(searchQuery);
  }, [query, currentPage]);

  const onPageChanged = data => {
    const { currentPage: crp, totalPages, pageLimit } = data;
    setCurrentPage(crp);
    const query = buildSearchQuery(crp, pageSize);
    props.getMyCafeDiscountsList(query);
  };

  const applyFilters = event => {
    const queryString = submitForm(event);
    setFilter(queryString);
  };

  const filterAndSort = () => {
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    setQuery(query);
    setCurrentPage(1);
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let queryI = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      queryI += `&${query || 'sort=createdAt-desc'}`;
      return queryI;
    }
  };

  const sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  return (
    <Spin spinning={props.getMyCafeDiscountsListLoading}>
      <section className="page-header">
        <h1>{locales('titles.manage.my.cafe.discounts')}</h1>
        <div className="form-actions">
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_DISCOUNT_REQUEST}>
            <Link to="/cafe-discounts/create" className="btn btn-success">
              <i className="fa fa-plus"></i>
              {locales('titles.add.new.cafe.discount.request')}
            </Link>
          </ShowForPermission>
        </div>
      </section>
      <section className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title">
            <i className="fa fa-pencil"></i>
            {locales('titles.my.cafe.discounts.list')}
          </h3>
        </div>
        <div className="panel-body">
          <CafeDiscountFilter applyFilters={applyFilters} filterAndSort={filterAndSort} />
          <CafeDiscountsList
            myCafeDiscountsList={props.myCafeDiscountsList}
            pageNumber={currentPage}
            pageSize={pageSize}
            sortType={sortType}
            sortTable={sortTable}
            totalRecords={props.totalRecords}
            onPageChange={onPageChanged}
          />
        </div>
      </section>
    </Spin>
  );
};

const mapStateToProps = state => {
  console.log('the state is ', state);
  return {
    getMyCafeDiscountsListLoading: state.cafeDiscountsReducer.getMyCafeDiscountsListLoading,
    getMyCafeDiscountsListFailed: state.cafeDiscountsReducer.getMyCafeDiscountsListFailed,
    getMyCafeDiscountsListError: state.cafeDiscountsReducer.getMyCafeDiscountsListError,
    getMyCafeDiscountsListMessage: state.cafeDiscountsReducer.getMyCafeDiscountsListMessage,
    myCafeDiscountsList: state.cafeDiscountsReducer.myCafeDiscountsList,
    totalRecords: state.cafeDiscountsReducer.myCafeDiscountsListTotalRecords
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getMyCafeDiscountsList: query => dispatch(cafeDiscountsActions.getMyCafeDiscountsList(query))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CafeDiscounts);
